import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { ShortlistState } from "PFTypes";

type UseBookButtonPermissionsProps = {
  state: ShortlistState;
  coowned: boolean;
  isReviewer: boolean;
};

export const useBookButtonPermissions = ({
  state,
  coowned,
  isReviewer
}: UseBookButtonPermissionsProps): boolean => {
  const { isEnabled, isPermittedToEdit } = useBookingModulePermissions();
  const { checkWriteAccessToAtLeastOneCategory } = useBookingCategories();
  const hasWriteAccessToAtLeastOneCategory = checkWriteAccessToAtLeastOneCategory({ demandRelated: true });

  return (
    (coowned || isReviewer) &&
    state === "filled" &&
    isEnabled &&
    isPermittedToEdit &&
    hasWriteAccessToAtLeastOneCategory
  );
};
